import { findLast, assign } from 'lodash';

import { Matrix, Frame } from 'cdl';

import { Tool } from '../view';

import { FiguresHandles } from './select-transform';

// [TODO] We should be able to allow multi selection

export const PowerClipTool = Tool.extend({ typeName: 'PowerClipTool',

  type: 'Final',
  toolbarName: 'powerClipTool',

  initTool( view, config ) {
    assign(this, config || {});
    this._data = null;

    this.handles = new FiguresHandles({ view, tool: this,

      editingItems: () => {
        const figure = this._selectedFigure;
        return figure ? [ figure ] : [];
      },

      computeItemsFrame_: () => {
        const figure = this._selectedFigure;
        const parent = this._selectedParent;
        const frame = figure.frame_();
        return frame.transformed( parent.rwPowerClipTransform() );
      },

      itemsEnabledContentEdit( /* view, figures */ ) {
        return false;
      },

      translateItems: ( items, offset ) => {
        this.transformItems(items,Matrix.translate(offset));
      },

      transformItems: this.transformItems.bind(this),

      commit$: () => {
        const parent = this._selectedParent;
        if( ! parent.usingPowerClipLink() ) {
          parent.invalidate();
        }
        view.commit$();
      }
    });
  },

  transformItems( items, transform ) { // Ignore items
    const figure = this._selectedFigure;
    const parent = this._selectedParent;

    const parentMatrix = parent.rwPowerClipTransform();

    // And transform again
    figure.transform( Matrix.concat( parentMatrix.inverted(), transform, parentMatrix ) );

    // We only need to invalidate the view, this should be automatic when
    // calling figure.transform(..) [TODO][PC]
    if( parent.usingPowerClipLink() ) {
      parent.invalidateView();
    }
  },

  link( view ) {
    view.on({ 'preview': this.on_preview }, this );

    this.handles.create();
  },

  unlink( view ) {
    view.un(this);
    this.handles.dispose();
  },

  dispose() {
    this.handles.dispose();
    this.callParent();
  },

  draw( config ) {
    this.handles.draw(config);
  },

  on_pointerdown({ view, event, isPrimary, docPoint }) {
    if( ! isPrimary ) {
      return;
    }

    const { handles } = this;
    if( handles._editionMode ) {
      this._endMode(event);
      return;
    }

    const leftClick = event.which === 1;
    if( ! leftClick ) {
      return;
    }

    if( handles.isHandle(event) ) {
      event.stopPropagation();
      handles.down(event);
    }
    else {

      const parent = event.figure; // [EVENTS] view.figureAtPoint( docPoint ); // get top most figure at point
      if( parent ) { // click directly on figure (not handle)?

        event.stopPropagation();

        // Find figure inside of powerclip to move
        const pcContent = parent.powerClipContents[0];
        const parentMatrixInv = parent.rwPowerClipTransform().inverted();
        const pcPoint = parentMatrixInv.apply(docPoint);
        if( pcContent ) {

          // [TODO] This needs to be abstracted
          let figure = findLast( pcContent.figures, f => f.containsPoint(pcPoint) );
          if( ! figure ) {
            // Try frame hit testing
            figure = findLast( pcContent.figures, f => f._outputFigure && f.frame_().contains(pcPoint) );
          }

          if( figure ) {
            this._figureClicked( figure, parent );

            view.render$() .then( () => {
            handles.down(event);
            });
          }
        }
      }
      else { // click on empty design area?

        this._selectedFigure = null;
        this._selectedParent = null;
        this.handles.update();
      }
    }
  },

  _figureClicked( figure, parent ) {

    this.view.activeDocument = parent.document;

    this._selectedFigure = figure;
    this._selectedParent = parent;

    this.handles.update();
    this.view.render$();
  },

  on_mousemove( event ) {
    this.handles.mousemove(event);
  },

  on_pointermove( event ) {
    this.handles.move(event);
  },

  on_pointerup( event ) {
    this.handles.up(event);
  },

  on_preview() {
    this.handles.update();
  },

  somethingToDraw() {
    return this.handles.visible;
  },

  needsToDrawFor( docIsland ) {
    const { frame } = this.handles;
    return !!frame && Frame.areOverlapping( docIsland.frame_(), this.handles.frame );
  }
});

Tool.PowerClip = PowerClipTool;



/** WEBPACK FOOTER **
 ** ./src/ui/tool/power-clip.js
 **/